import { getData, postData } from './api-base.service'

export const getPartnerSsoConfig = () => {
  return getData('/SsoAuth/Config');
}

export const createSsoTicket = (courseId, courseName) => {
  return postData('/SsoAuth/CreateSsoTicket', {
    CourseId: courseId,
    CourseName: courseName
  });
}



// WEBPACK FOOTER //
// ./src/service/ssoAuth.service.js